export const vscroll = () => {
    return '::-webkit-scrollbar {width: 7px;height: 7px}::-webkit-scrollbar-track {background: #f1f1f1;}::-webkit-scrollbar-thumb {background: #41505e;}::-webkit-scrollbar-thumb:hover {background: #555;}';
}

export const imgcover = () =>{
    return 'min-width: 100%;min-height: 100%;object-fit: cover;object-position: center center;'
}